/**
 * li-optimistic-variant-image.js
 *
 * Optimistic carousel navigation on variant change.
 * Instantly scrolls the media gallery slideshow to the selected variant's
 * featured image while Horizon's server fetch + morph runs in the background.
 *
 * Safe by design:
 * - Only acts when the clicked option has a data-variant-id (single-option resolve)
 * - Only acts when the variant has a featured_media in the pre-embedded map
 * - Only acts when a matching slide exists in the DOM (hide_variants must be false)
 * - If anything fails, does nothing — Horizon's normal flow handles it
 * - The morph always overwrites our state when it arrives, so no stale state
 */

(function () {
  'use strict';

  /** @type {Record<string, number>|null} variant ID → media ID */
  let variantMediaMap = null;

  function getMediaMap() {
    if (variantMediaMap) return variantMediaMap;
    const script = document.getElementById('li-variant-image-map');
    if (!script) return null;
    try {
      variantMediaMap = JSON.parse(script.textContent);
      return variantMediaMap;
    } catch {
      return null;
    }
  }

  function handleVariantChange(e) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;

    const variantId = input.dataset?.variantId;
    if (!variantId) return;

    const map = getMediaMap();
    if (!map) return;

    const mediaId = map[variantId];
    if (!mediaId) return;

    // Find the media gallery and its slideshow
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow || typeof slideshow.select !== 'function') return;

    // Find the slide containing the matching media
    const mediaEl = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    if (!mediaEl) return;

    const slideEl = mediaEl.closest('slideshow-slide');
    if (!slideEl) return;

    // Get the slide index from the slides ref array
    const slides = slideshow.refs?.slides;
    if (!slides) return;

    const slideIndex = slides.indexOf(slideEl);
    if (slideIndex < 0) return;

    // Navigate the slideshow to this slide
    slideshow.select(slideIndex);
  }

  // Attach listener — uses capture phase to fire before variant-picker's own handler
  document.addEventListener('change', function (e) {
    const variantPicker = e.target instanceof Element && e.target.closest('variant-picker');
    if (variantPicker) {
      handleVariantChange(e);
    }
  }, true);
})();
